import { ACTIVITY_WORKFLOW_STATUS } from 'app/components/selectors/SelectActivityWorkflowStatus/SelectActivityWorkflowStatus.constants';
import i18next from 'app/translations/i18n';
import { MAX, REQUIRED } from 'app/utils/yupMessage';
import * as Yup from 'yup';

export const MODEL_TEXT = 'activity';

export const Model = {
  description: '',
  erp_id: '',
  guid: null,
  is_active: true,
  is_available_offline: true,
  name: '',
  workflow_status: ACTIVITY_WORKFLOW_STATUS.DRAFT,
};

export const ModelYup = Yup.object().shape({
  description: Yup.string(),
  erp_id: Yup.string().max(250, MAX),
  is_active: Yup.boolean(),
  is_available_offline: Yup.boolean(),
  name: Yup.string().max(250, MAX).required(REQUIRED),
  workflow_status: Yup.string(),
});

export const ModelErrors = [{ errno: 1062, codeString: 'ER_DUP_ENTRY', message: i18next.t('contents:error_erp') }];

export const ModelSuccess = [{ id: 'create', message: i18next.t('contents:activity_create_success') }];

export function sanitizeData(data = {}) {
  return {
    ...Model,
    description: data.description ?? Model.description,
    erp_id: data.erp_id ?? Model.erp_id,
    guid: data.guid ?? Model.guid,
    is_active: data.status === 'active',
    is_available_offline: data.is_available_offline !== 0,
    name: data.name ?? Model.name,
    workflow_status: data.workflow_status ?? Model.workflow_status,
  };
}
